const getters = {
    headerActiveId: state => state.public.headerActiveId,
    isMobile: state => state.public.isMobile,
    isShowLoginModal: state => state.public.isShowLoginModal,
    schoolConfigInfo: state => state.public.schoolConfiInfo,
    userInfo: state => state.public.userInfo,
}
export default getters